const QUANTITY_TYPE = {
  SHOPPING_CART: 1,
  PRODUCT_DETAIL: 2,
  WISHLIST_DETAIL: 3,
}
export default QUANTITY_TYPE
